import api from '../../plugins/api';

const getBitrixImportStatus = (jobId) => api.get('/api/crm/cars/bitrixStock/status/' + jobId);

export default getBitrixImportStatus;
